import React, { FC } from 'react';
import { FloatingPanel } from 'components/UI/FloatingPanel';
import InputArea from '../../InputArea';
import SelectedContainer from '../../SelectedContainer';
import { useRenderDynamicCatalog } from './hooks/useRenderDynamicCatalog';
import { IRenderDynamicCatalogProps } from './types';

export const RenderDynamicCatalog: FC<IRenderDynamicCatalogProps> = ({
  item,
  currentValue,
  currentKey,
  source,
  formikKey,
  formik,
}) => {
  const { dynamicData, dynamicValue, notExistKeys, onChange } =
    useRenderDynamicCatalog(
      item,
      currentValue,
      currentKey,
      source,
      formikKey,
      formik,
    );

  return (
    <>
      {Object.keys(dynamicData).map((dynamicKey) => (
        <FloatingPanel
          key={`${currentKey}-${dynamicKey}`}
          placement="left"
          content={({ close }) => (
            <InputArea
              value={dynamicValue}
              onClose={close}
              onChange={onChange}
              notExistKeys={notExistKeys ? notExistKeys[currentKey] : []}
            />
          )}
          offset={30}
        >
          {({ isOpen }) => (
            <SelectedContainer
              label={item.label}
              isOpen={isOpen}
              values={dynamicValue}
              onCleanField={() =>
                formik.setFieldValue(`reportFilters.filterBy.${currentKey}`, [])
              }
            />
          )}
        </FloatingPanel>
      ))}
    </>
  );
};
